import { growthBookConfig } from './growthBook.config'
import { loginConfig } from './login.config'
import { autoVasConfig } from './autoVas.config'

const conf = {
  prod: {
    // Analytics Keys (Client-side)
    segmentKey: {
      ackoSeo: 'HXYpaTGkLGPf8NCthRHd56vpihGevRk6',
      ackoDrive: 'diuEtVmmIty3lnYuipmsohzpEGmGGR3J',
      homePage: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      ackoBrand: 'h2tIdlVfvi0CmHIgXIA9K3OEJAT6IR5N',
      ackoCareer: 'FAHnZoRSv5GNU2BmEqUqddQTIB4Rked7',
      ackoShare: 'nFRoS1iJbl3an6jRzwncfuL6PmumnnRw',
      aboutUsPage: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      ackoEnterprise: 'Db7qg80zZq79SffgRblhPHcSuBwraILN',
      brandHubPage: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      mediaKitPage: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      reviewsTestimonialPage: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      dhoniPressRelease: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
    },

    // Captcha (Client-side)
    hcaptchaSitekey: '63e15280-5462-4d9d-9275-4d0632a362c3',
    apiService: 'https://www.acko.com',
    // Public URLs (Client-side)
    ackoBaseUrl: 'https://www.acko.com',
    ackoDriveBaseUrl: 'https://www.ackodrive.com',
    accountsBaseUrl: 'https://accounts.acko.com',
    copilotUrl: 'https://www.acko.com/p/acko-assist-v2/chat?journey=acko',
    autoVasConfig: autoVasConfig.prod,
    // Public API Endpoints (Client-side)
    ackontentBaseUrl: 'https://www.acko.com/ackontent/recommendation/api/v2',
    catalogServiceUrl: 'https://ackodrive-catalog-service.ackodrive.com',
    ackoDriveEndpoint: 'https://workspace.ackodrive.com',
    loginConfig: loginConfig.prod,
    growthBookConfig: growthBookConfig.prod,
    // Feature Configs (Client-side)
  },
  'pre-prod': {
    segmentKey: {
      ackoSeo: 'HXYpaTGkLGPf8NCthRHd56vpihGevRk6',
      ackoDrive: 'diuEtVmmIty3lnYuipmsohzpEGmGGR3J',
      homePage: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      ackoCareer: 'FAHnZoRSv5GNU2BmEqUqddQTIB4Rked7',
      ackoShare: 'nFRoS1iJbl3an6jRzwncfuL6PmumnnRw',
      aboutUsPage: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      brandHubPage: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      mediaKitPage: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      reviewsTestimonialPage: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
      dhoniPressRelease: '37Tcc2RQFS0OPMFTLUJWcuwPUXShBpHl',
    },
    hcaptchaSitekey: '63e15280-5462-4d9d-9275-4d0632a362c3',
    autoVasConfig: autoVasConfig.prod,
    apiService: 'https://www.acko.com',
    ackoBaseUrl: 'https://www.acko.com',
    ackoDriveBaseUrl: 'https://www.ackodrive.com',
    accountsBaseUrl: 'https://accounts.acko.com',
    copilotUrl: 'https://www.acko.com/p/acko-assist-v2/chat?journey=acko',
    ackontentBaseUrl: 'https://www.acko.com/ackontent/recommendation/api/v2',
    catalogServiceUrl: 'https://ackodrive-catalog-service.ackodrive.com',
    ackoDriveEndpoint: 'https://workspace.ackodrive.com',
    loginConfig: loginConfig.prod,
    growthBookConfig: growthBookConfig.prod,
  },
  master: {
    segmentKey: {
      ackoSeo: 'LHxVP6yUVPd1An7vjC0KHC57E2I9jhA6',
      ackoDrive: 'g3ap5Yu91V2qsHVvBpzaGvTY3DG0szUJ',
      homePage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      ackoBrand: 'thfdUv8SdqfVn1y9VPeiJorqR1qaXECQ',
      ackoCareer: 'FAHnZoRSv5GNU2BmEqUqddQTIB4Rked7',
      ackoShare: 'a8oWLN0un0u9mge2DDceADPVMioecr9u',
      aboutUsPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      ackoEnterprise: 'OmV7jAWTCgzH5jCxRpM1UBbAJfGUsOOj',
      brandHubPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      mediaKitPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      reviewsTestimonialPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      dhoniPressRelease: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
    },
    hcaptchaSitekey: '585c1d16-fccf-405e-8917-31308fa419f2',
    autoVasConfig: autoVasConfig.master,
    ackoBaseUrl: 'https://www.ackodev.com',
    apiService: 'https://www.ackodev.com',
    ackoDriveBaseUrl: 'https://ad-customer-website.uat.ackodrive.com',
    accountsBaseUrl: 'https://accounts.ackodev.com',
    copilotUrl: 'https://www.ackodev.com/p/acko-assist-v2/chat?journey=acko',
    ackontentBaseUrl: 'https://www.ackodev.com/ackontent/recommendation/api/v2',
    catalogServiceUrl: 'https://ackodrive-catalog-service.ackodrive.com',
    ackoDriveEndpoint: 'https://workspace.internal.ackodrive.com',
    loginConfig: loginConfig.master,
    growthBookConfig: growthBookConfig.master,
  },
  local: {
    segmentKey: {
      ackoSeo: 'LHxVP6yUVPd1An7vjC0KHC57E2I9jhA6',
      ackoDrive: 'g3ap5Yu91V2qsHVvBpzaGvTY3DG0szUJ',
      homePage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      ackoBrand: 'thfdUv8SdqfVn1y9VPeiJorqR1qaXECQ',
      ackoCareer: 'FAHnZoRSv5GNU2BmEqUqddQTIB4Rked7',
      ackoShare: 'a8oWLN0un0u9mge2DDceADPVMioecr9u',
      aboutUsPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      ackoEnterprise: 'OmV7jAWTCgzH5jCxRpM1UBbAJfGUsOOj',
      brandHubPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      mediaKitPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      reviewsTestimonialPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      dhoniPressRelease: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
    },
    hcaptchaSitekey: '585c1d16-fccf-405e-8917-31308fa419f2',
    autoVasConfig: autoVasConfig.local,
    ackoBaseUrl: 'https://www.ackodev.com',
    apiService: 'https://www.ackodev.com',
    ackoDriveBaseUrl: 'https://www.ackodrive.com',
    accountsBaseUrl: 'https://accounts.ackodev.com',
    copilotUrl: 'https://www.ackodev.com/p/acko-assist-v2/chat?journey=acko',
    ackontentBaseUrl: 'https://www.ackodev.com/ackontent/recommendation/api/v2',
    catalogServiceUrl: 'https://ackodrive-catalog-service.ackodrive.com',
    ackoDriveEndpoint: 'https://workspace.internal.ackodrive.com',
    loginConfig: loginConfig.local,
    growthBookConfig: growthBookConfig.local,
  },
  dev: {
    segmentKey: {
      ackoSeo: 'LHxVP6yUVPd1An7vjC0KHC57E2I9jhA6',
      ackoDrive: 'g3ap5Yu91V2qsHVvBpzaGvTY3DG0szUJ',
      homePage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      ackoBrand: 'thfdUv8SdqfVn1y9VPeiJorqR1qaXECQ',
      ackoCareer: 'a8oWLN0un0u9mge2DDceADPVMioecr9u',
      ackoShare: 'a8oWLN0un0u9mge2DDceADPVMioecr9u',
      aboutUsPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      brandHubPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      mediaKitPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      reviewsTestimonialPage: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
      dhoniPressRelease: 'Z3eilwRIxGJtrkzoyMSCET0GdRVuKzYK',
    },
    autoVasConfig: autoVasConfig.dev,
    hcaptchaSitekey: '585c1d16-fccf-405e-8917-31308fa419f2',
    ackoBaseUrl: 'https://www.ackodev.com',
    apiService: 'https://www.ackodev.com',
    ackoDriveBaseUrl: 'https://ad-customer-website.dev.ackodrive.com',
    accountsBaseUrl: 'https://accounts.ackodev.com',
    copilotUrl: 'https://www.ackodev.com/p/acko-assist-v2/chat?journey=acko',
    ackontentBaseUrl: 'https://www.ackodev.com/ackontent/recommendation/api/v2',
    catalogServiceUrl: 'https://ackodrive-catalog-service-uat.dev.ackodrive.com',
    ackoDriveEndpoint: 'https://workspace.internal.ackodrive.com',
    loginConfig: loginConfig.dev,
    growthBookConfig: growthBookConfig.dev,
  },
}

export const getConfig = envValue => conf[envValue]
